const numberWithoutCode = (v) => v.number.replace(v.code, '');

export default numberWithoutCode;
